// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 656 ? "23e5971a" : chunkId) + "." + {"656":"3fcd832d8e5a2d4d","829":"d2b9fcc88f260da9"}[chunkId] + ".js";
};